import React, { useEffect, useState } from "react";
import { Button, Modal } from "react-bootstrap";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

import api, { api_without_cancellation } from "../../../api/api";
import avatarImage from "../../../assets/images/avatar.svg";
import incidentIcon from "../../../assets/images/incident.svg";
import birthdayIcon from "../../../assets/images/birthdayicon.svg";
import {
  calculateAge,
  formatCalendarDate,
  formatPhoneNumber,
  getCaseId,
  getClientId,
  setCaseId,
  setClientId,
} from "../../../Utils/helper";
import { setComponentLoadingEffect } from "../../../Redux/common/Loader/action";
import {
  fetchAllPages,
  fetchAllStages,
  fetchCurrentCase,
  setCaseSummary,
} from "../../../Redux/caseData/caseDataSlice";
import { fetchCaseSummary, fetchHeaderSummary } from "../../../api/case";
import { setBlurEffect } from "../../../Redux/header_blur/action";
import { setHeaderName } from "../../../Redux/header_name/action";
import { setHeaderSummary } from "../../../Redux/header/headerDataSlice";
import mixColorWithWhite from "../../TreatmentPage/utils/helperFn";

import HIPAAComplianceForm from "./agreement-form";
import "./review-modal.css";

// function formatFixedDate(utcString, timeZone = "America/Los_Angeles") {
//   if (!utcString) return "";

//   const date = new Date(utcString);
//   return new Intl.DateTimeFormat("en-US", {
//     timeZone,
//     year: "numeric",
//     month: "numeric",
//     day: "2-digit",
//   }).format(date);
// }

function ReviewModal({ show, handleClose, inviteData, fetchInvites }) {
  const loggedInInfo = useSelector((state) => state.loggedInfo.loggedInInfo);

  const [dateTime, setDateTime] = useState("");
  const [dateTimeApi, setDateTimeApi] = useState("");
  const [dateTimeWithZone, setDateTimeWithZone] = useState("");
  const [isAgreed, setIsAgreed] = useState(false);
  const clientId = getClientId();
  const caseId = getCaseId();
  const navigate = useNavigate();
  const client = inviteData?.client;
  const profilePic = client?.profile_pic_19p || client?.profile_pic_29p || client?.profile_pic;
  const clientName = [client?.last_name, client?.first_name].filter(Boolean).join(", ");
  const age = calculateAge(client?.birthday);

  useEffect(() => {
    const now = new Date();

    // For UI display
    const localDateTime = now.toLocaleString();

    // ISO string for accepted_at
    const isoDateTime = now.toISOString();

    // Timezone name for timezone field
    const timezoneName = Intl.DateTimeFormat().resolvedOptions().timeZone;

    setDateTime(localDateTime);
    setDateTimeApi(isoDateTime); // Used for `accepted_at`
    setDateTimeWithZone(timezoneName); // Used for `timezone`
  }, []);

  const [showRejectionMessage, setShowRejectionMessage] = useState(false);
  const [rejectionMessage, setRejectionMessage] = useState("");
  const dispatch = useDispatch();

  const handleAccept = async (e) => {
    try {
      const data = {
        link_id: inviteData?.link_id,
        decision: true,
        timestamp: dateTimeApi,
        accepted_user_ip: loggedInInfo?.ip_address,
        timezone: dateTimeWithZone,
      };

      const response = await api_without_cancellation.post(
        "/api/treatment-opt/invites-decision/",
        data
      );

      const data2 = await response.data;

      if (response.status === 200 || response.status === 201) {
        fetchInvites();
        handleClose();

        if (clientId === "undefined" && caseId === "undefined") {
          e.preventDefault();

          dispatch(setComponentLoadingEffect("medicalProviders", true));

          dispatch(setComponentLoadingEffect("detailBar", true));
          const clientID = data2?.client_id;
          const caseID = data2?.case_id;
          await api.get(`/api/switch_client/${clientID}/${caseID}/1/`);

          setClientId(clientID);
          setCaseId(caseID);
          dispatch(fetchCurrentCase(clientID, caseID));
          dispatch(fetchAllStages());

          fetchHeaderSummary(clientID, caseID)
            .then((data) => {
              dispatch(setHeaderSummary(data));
            })
            .catch(() => {});

          fetchCaseSummary(clientID, caseID)
            .then((data) => {
              dispatch(setCaseSummary(data));
              dispatch(fetchAllPages(caseID));
              dispatch(setBlurEffect(false));
              dispatch(setHeaderName("Case"));
              document.body.classList.remove("modal-open", "has-blurred-bg");
              const menuContainer = document.getElementById("padding-top-165");
              if (menuContainer) {
                menuContainer.style.filter = "";
              }
              const divToRemove = document.querySelector(".header-blur-show");
              if (divToRemove) {
                document.body.removeChild(divToRemove);
              }
              navigate(`/bp-case/${clientID}/${caseID}`, {
                replace: true,
              });
            })
            .catch((err) => {
              console.error("Error fetching case summary:", err);
            });
        }
      }
    } catch (error) {
      console.error("Error while accepting invite:", error);
      toast.error("New User cannot be added while on free plan");
    } finally {
      setShowRejectionMessage(false);
    }
  };

  const handleRejectSubmitted = async () => {
    try {
      const data = {
        link_id: inviteData?.link_id,
        decision: false,
        timestamp: dateTimeApi,
        accepted_user_ip: loggedInInfo?.ip_address,
        timezone: dateTimeWithZone,
        reason: rejectionMessage,
      };

      const response = await api_without_cancellation.post(
        "/api/treatment-opt/invites-decision/",
        data
      );

      if (response.status === 200) {
        fetchInvites();
        handleClose();
      }
    } catch (error) {
      console.error("Error while rejecting invite:", error);
    }
  };

  const handleReject = () => {
    setShowRejectionMessage(true);
  };

  return (
    <Modal
      show={show}
      onHide={handleClose}
      dialogClassName="provider-referral-review-dialog"
      contentClassName="custom-modal-new-provider provider-referral-review-modal"
      aria-labelledby="provider-referral-review-title"
      centered
    >
      <Modal.Header className="text-center height-25 p-0 bg-primary popup-heading-color justify-content-center">
        <Modal.Title
          className="height-25 font-weight-semibold text-uppercase popup-heading-color d-flex align-items-center"
          id="provider-referral-review-title"
          style={{ fontSize: "14px", fontWeight: "600" }}
        >
          Accept Invite Modal
        </Modal.Title>
      </Modal.Header>

      <Modal.Body className="provider-referral-review-body">
        <table
          className="table table-borderless table-striped table-treatment has-specialty-icon has-height-25 mt-0 provider-referral-review-table"
          id="treatment-summary-table"
        >
          <thead>
            <tr id="tb-header">
              <th className="provider-referral-review-spacer" aria-hidden="true" />
              <th scope="col">Referral</th>
              <th className="provider-referral-review-spacer" aria-hidden="true" />
              <th scope="col" className="text-center color-grey-2">
                Treatment First Referring Medical Provider
              </th>
              <th className="provider-referral-review-spacer" aria-hidden="true" />
            </tr>
          </thead>
          <tbody>
            <tr>
              <td className="provider-referral-review-spacer" aria-hidden="true" />
              <td className="td-autosize provider-referral-review-cell provider-referral-review-case">
                <div className="provider-referral-review-mobile-heading" aria-hidden="true">
                  Referral
                </div>
                <div className="provider-referral-review-line">
                  <span className="ic m-r-5 ic-avatar ic-15 has-avatar-icon has-cover-img">
                    <img
                      src={profilePic || avatarImage}
                      className="output-3 theme-ring"
                      width={15}
                      height={15}
                      style={profilePic ? undefined : { background: "var(--primary-30)" }}
                      alt=""
                      onError={(event) => {
                        event.currentTarget.onerror = null;
                        event.currentTarget.src = avatarImage;
                        event.currentTarget.style.background = "var(--primary-30)";
                      }}
                    />
                  </span>
                  <span>{clientName}</span>
                </div>
                <div className="provider-referral-review-line justify-content-between">
                  <div className="d-flex align-items-center">
                    <img
                      src={birthdayIcon}
                      className="provider-referral-review-icon m-r-5"
                      width={15}
                      height={15}
                      alt=""
                    />
                    <span>{formatCalendarDate(client?.birthday)}</span>
                  </div>
                  {age !== "" && (
                    <div className="d-flex align-items-center m-l-5">
                      <span className="text-primary-25 m-r-5">age</span>
                      <span>{age}</span>
                    </div>
                  )}
                </div>
                <div className="provider-referral-review-line">
                  {inviteData?.case_type?.casetype_icon && (
                    <img
                      src={inviteData.case_type.casetype_icon}
                      className="provider-referral-review-icon m-r-5"
                      width={15}
                      height={15}
                      alt=""
                    />
                  )}
                  <span>{inviteData?.case_type?.name}</span>
                </div>
                <div className="provider-referral-review-line">
                  <img
                    src={incidentIcon}
                    className="provider-referral-review-icon m-r-5"
                    width={15}
                    height={15}
                    alt=""
                  />
                  <span>{formatCalendarDate(inviteData?.incident_date)}</span>
                </div>
              </td>
              <td className="provider-referral-review-spacer" aria-hidden="true" />
              <td className="td-autosize provider-referral-review-cell">
                <div className="provider-referral-review-mobile-heading" aria-hidden="true">
                  Treatment First Referring Medical Provider
                </div>
                <div
                  className="provider-referral-review-line"
                  style={{ background: mixColorWithWhite(inviteData?.specialty?.color, 10) }}
                >
                  {inviteData?.specialty && (
                    <>
                      <span
                        className="provider-referral-review-specialty m-r-5"
                        style={{ background: inviteData.specialty.color }}
                      >
                        {inviteData.specialty.name?.[0]}
                      </span>
                      <span className="p-r-5">{inviteData.specialty.name}</span>
                    </>
                  )}
                </div>
                <div className="provider-referral-review-line">
                  {inviteData?.provider_office_name}
                </div>
                <div className="provider-referral-review-line">
                  {formatPhoneNumber(inviteData?.provider_phone)}
                </div>
                <div className="provider-referral-review-line">{inviteData?.provider_email}</div>
              </td>
              <td className="provider-referral-review-spacer" aria-hidden="true" />
            </tr>
          </tbody>
        </table>
        <div className="provider-referral-review-agreement">
          <HIPAAComplianceForm setIsAgreed2={setIsAgreed} />
        </div>
      </Modal.Body>

      <div className="provider-referral-review-toolbar">
        <div className="provider-referral-review-user">
          <span className="ic-avatar ic-19 has-cover-img sidebar-pic">
            <img
              src={loggedInInfo?.user?.profile_pic || avatarImage}
              width={19}
              height={19}
              alt=""
            />
          </span>
          <span>
            {loggedInInfo?.user?.first_name} {loggedInInfo?.user?.last_name}
          </span>
        </div>
        <div className="provider-referral-review-field provider-referral-review-date">
          <input
            type="text"
            aria-label="Date and time"
            className="form-control height-25"
            value={dateTime}
            readOnly
          />
        </div>
        <input type="hidden" name="dateTimeWithZone" value={dateTimeWithZone} />
        <div className="provider-referral-review-field provider-referral-review-ip">
          <input
            type="text"
            aria-label="IP address"
            className="form-control height-25"
            value={loggedInInfo?.ip_address || ""}
            readOnly
          />
        </div>
        <div className="provider-referral-review-actions">
          <Button
            variant={showRejectionMessage ? "secondary" : "success"}
            className={`height-25 ${showRejectionMessage ? "disabled-like" : ""}`}
            disabled={!isAgreed}
            onClick={handleAccept}
          >
            Accept
          </Button>
          <Button
            variant={showRejectionMessage ? "danger" : "secondary"}
            className={`height-25 ${!showRejectionMessage ? "disabled-like" : ""}`}
            disabled={!isAgreed}
            onClick={handleReject}
          >
            Reject
          </Button>
        </div>
      </div>

      {showRejectionMessage && (
        <>
          <div className="provider-referral-review-rejection">
            <label htmlFor="provider-referral-rejection-reason">Rejection reason</label>
            <textarea
              id="provider-referral-rejection-reason"
              className="form-control"
              rows={2}
              placeholder="Enter rejection message…"
              value={rejectionMessage}
              onChange={(e) => setRejectionMessage(e.target.value)}
            />
          </div>
          <Modal.Footer className="provider-referral-review-footer">
            <Button variant="secondary" onClick={() => handleClose(false)}>
              Cancel
            </Button>
            <Button
              variant={rejectionMessage.trim() ? "success" : "secondary"}
              disabled={rejectionMessage.trim() === ""}
              onClick={handleRejectSubmitted}
            >
              Submit
            </Button>
          </Modal.Footer>
        </>
      )}
    </Modal>
  );
}

export default React.memo(ReviewModal);
